import { useEffect, useMemo, type PropsWithChildren } from "react";
import type {
  HyperTableCustomFilter as HyperTableCustomFilterType,
  HyperTableFilterBoth,
} from "../../types";
import { useToolbarFilters } from "./HyperTableToolbar";
import { markHyperTableFilterComponent } from "./is-filter-child";

interface HyperTableCustomFilterProps<Entity>
  extends Omit<HyperTableFilterBoth<Entity>, "caption">,
    HyperTableCustomFilterType<Entity>,
    PropsWithChildren {}

function HyperTableCustomFilterComponent<Entity extends any>(
  props: HyperTableCustomFilterProps<Entity>,
) {
  const { children, icon, ...rest } = props;
  const { filterActions } = useToolbarFilters<Entity>();

  const filter = useMemo(
    () => ({
      caption: children ?? "~No Caption~",
      icon,
      ...rest,
    }),
    [children, JSON.stringify(rest)],
  );

  useEffect(() => {
    if (filterActions.has(filter)) filterActions.update(filter);
  }, [filter]);

  useEffect(() => {
    filterActions.add(filter);
    return () => {
      filterActions.remove(filter);
    };
  }, []);

  return null;
}

export const HyperTableCustomFilter = markHyperTableFilterComponent(
  HyperTableCustomFilterComponent,
);
